import * as React from 'react';
import { PageChorinitia } from '../genericComponents/Page/PageChorinitia';
import { UserRole } from '../../types/UserRole';
import { FormAdhere1 } from './internalComponents/Adhere1';
import { FormAdhere2 } from './internalComponents/Adhere2';
import { FormAdhere3 } from './internalComponents/Adhere3';
import LoginServices from '../../services/LoginServices';

interface Props {
}

interface State {
    numForm: number;
}

/**
 * ce composant contient la page d'affichage des fomulaire d'adhesion
 */
export class MembershipPage extends React.Component {

    props: Props;
    state: State;
    // private membership?: MembershipPage;

    constructor(props: Props) {
        super(props);
        this.state = {
            numForm: 1,
        };
    }

    render() {
        return (
            <PageChorinitia
                allowedUsers={[
                    UserRole.USER,
                ]}
            >
                {this.SwitchForm(this.state.numForm)}
            </PageChorinitia>
        );
    }

    private SwitchForm: (n: number) => JSX.Element = (idPage: number) => {
        if (idPage === 1) {
            return (
                <FormAdhere1
                    disabled={false}
                    hidden={false}
                    switch={this.SetForm}
                    user_id={LoginServices.getInstance().getUserId()!}
                />
            );
        } else if (idPage === 2) {
            return (
                <FormAdhere2
                    disabled={false}
                    hidden={false}
                    switch={this.SetForm}
                    user_id={LoginServices.getInstance().getUserId()!}
                />
            );
        } else {
            return (
                <FormAdhere3
                    disabled={false}
                    hidden={false}
                    switch={this.SetForm}
                    user_id={LoginServices.getInstance().getUserId()!}
                />
            );
        }
    }

    private SetForm = (n: number) => {
        this.setState({ numForm: n });
    }
}


// WEBPACK FOOTER //
// ./src/components/MembershipPage/MembershipPage.tsx